import { render, staticRenderFns } from "./TooltipBudgetplanung.vue?vue&type=template&id=b6663764&scoped=true&"
import script from "./TooltipBudgetplanung.vue?vue&type=script&lang=js&"
export * from "./TooltipBudgetplanung.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6663764",
  null
  
)

export default component.exports